<script setup lang="ts">
import AppSidebar from '@/components/core/shell/AppSidebar.vue';
import AppTopbar from '@/components/core/shell/AppTopbar.vue';
</script>

<template>
    <div class="depot-app-root grid min-h-screen bg-[color:var(--bg)]">
        <AppSidebar />
        <div class="flex min-w-0 flex-col">
            <AppTopbar />
            <main class="mx-auto w-full max-w-[1320px] px-8 pb-24 pt-7 max-md:px-4 max-md:pb-20">
                <RouterView v-slot="{ Component }" :key="$route.fullPath">
                    <transition name="fade" mode="out-in">
                        <component :is="Component"></component>
                    </transition>
                </RouterView>
            </main>
        </div>
    </div>
</template>

<style scoped>
/* grid-template-columns can't be expressed with a single Tailwind utility
   when the value is a CSS variable; using a one-line style block keeps it
   in this component rather than in a global stylesheet. Mirrors depot.vue so
   both shells share the same responsive column behaviour. */
.depot-app-root {
    grid-template-columns: var(--sidebar-w) 1fr;
}
@media (max-width: 980px) {
    .depot-app-root {
        grid-template-columns: 64px 1fr;
    }
}
@media (max-width: 760px) {
    .depot-app-root {
        grid-template-columns: 1fr;
    }
}
</style>
